<template>
  <div class="animated fadeIn col-md-12">
    <SearchCard
      :filterCatch="true"
      :title="$lang.surveyLang.my_survey_list"
      :url="$config.api_url + $config.survey.my_survey"
      :html="false"
      :allowFields="$lang.search_parvandeh_fildes"
      ref="mySurvey"
      @updatePermissions="updatePermissions"
      :hasAdd="true"
      @handleAdd="goToAddSurvey"
    >
      <template slot="html" slot-scope="{ item }">
        <b-col
          cols="12"
          class="py-1 mb-3 border-bottom d-flex align-items-center justify-content-between"
        >
          <div class="d-flex align-items-center">
            <span
              class="mr-1 fs_1_3rem w_h_35 border bg-light rounded-circle d-flex align-items-center justify-content-center"
            >
              <i class="fas fa-comment text-secondary" />
            </span>
            <b
              class="px-1 fs_1rem"
              v-text="`${pathOr('', ['survey_group', 'name'], item)}`"
            />
          </div>
          <small class="text-muted">
            <div
              v-b-tooltip
              title="ثبت کننده"
              v-if="pathOr(null, ['created_by'], item)"
            >
              <i class="fas fa-user mr-1" />
              <span v-text="pathOr('', ['created_by'], item)" />
            </div>
            <div v-b-tooltip title="زمان ایجاد">
              <i class="fas fa-clock mr-1" />
              <span v-text="pathOr('', ['created_at', 'jalali'], item)" />
            </div>
          </small>
        </b-col>
        <b-col cols="12" md="12">
          <b-row>
            <b-col cols="12" md="auto" class="text-md-left text-center">
              <b-img-lazy
                fluid
                thumbnail
                :onerror="$config.images.onerrorDefaultImg"
                :src="pathOr('', ['person', 'attachment'], item)"
                class="bg-white"
                width="120"
              />
            </b-col>
            <b-col cols="12" md="">
              <b-row>
                <b-col cols="12" md="12" class="py-1">
                  <i class="fas fa-user text-info mr-1" />
                  <ProfileBoxPopupWrapper
                    :data="item"
                    deskTopPopupClass="top-230"
                    nameClass="color-complementary"
                  />
                </b-col>
                <b-col cols="12" md="12" class="py-1">
                  <i class="fas fa-address-card text-info mr-1" />
                  <span
                    class="text-muted"
                    v-b-tooltip.hover
                    :title="$lang.surveyLang.national_code"
                    v-text="pathOr('', ['person', 'national_code'], item)"
                  />
                </b-col>
                <b-col cols="12" md="12" class="py-1">
                  <i class="fas fa-folder text-info mr-1" />
                  <span
                    class="text-muted"
                    v-b-tooltip.hover
                    :title="$lang.surveyLang.parvandeh_number"
                    v-text="
                      pathOr(
                        '',
                        ['person', 'parvandeh', 'parvandeh_number'],
                        item
                      )
                    "
                  />
                </b-col>
                <b-col cols="12" md="12" class="py-1">
                  <i class="fas fa-comment text-info mr-1" />
                  <span
                    class="text-muted"
                    v-html="nl2br(pathOr('', ['survey_text'], item))"
                  />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          cols="12"
          md="12"
          class="py-1 mt-3 border-top d-flex align-items-center justify-content-between"
        >
          <div />
          <div>
            <b-button
              v-if="
                includes('modir_system', roles) || includes('edit', permissions)
              "
              class="m-1"
              size="sm"
              variant="outline-danger"
              @click="showConfirmModal(item)"
            >
              <i class="fas fa-trash mr-1" />
              {{ $lang.remove }}
            </b-button>
            <b-button
              v-if="
                includes('modir_system', roles) || includes('edit', permissions)
              "
              variant="outline-success"
              size="sm"
              @click="goToEditSurvey(item)"
            >
              <i class="fas fa-edit mr-1" />
              <b v-text="$lang.edit" />
            </b-button>
          </div>
        </b-col>
      </template>
    </SearchCard>
    <Confirm
      v-model="confirmModal"
      :title="`حذف نظر`"
      :description="confirmDescription"
      dynamicClass=""
      :loading="loading"
      :preventDefault="true"
      :cancel-title="$lang.no"
      :ok-title="$lang.yes"
      @cancel="confirmModal = false"
      @ok="removeSurvey"
    />
  </div>
</template>

<script>
import SearchCard from "@/components/base/searchCard";
import Confirm from "@/components/base/confirm";
import { pathOr, includes } from "ramda";
import { generateStoreGetters, nl2br } from "@/shared/utils";
import { ProfileBoxPopupWrapper } from "@/components/re-design";

export default {
  components: {
    SearchCard,
    Confirm,
    ProfileBoxPopupWrapper,
  },
  data() {
    return {
      permissions: [],
      currentItem: null,
      loading: false,
      confirmModal: false,
    };
  },
  computed: {
    confirmDescription() {
      return `دقت کنید که نظر و کلیه پیوست‌های آن حذف خواهند شد.
      <br>
      <br>
      <strong>${this.$lang.are_you_sure}</strong>
      `;
    },
    roles() {
      return generateStoreGetters(["userInfo", "roles"]) || [];
    },
  },
  methods: {
    pathOr,
    includes,
    nl2br,
    async getData() {
      await this.$refs.mySurvey.getItems();
      this.$emit("updateRefreshGetData", false);
    },
    updatePermissions(data) {
      this.permissions = [...data];
    },
    goToAddSurvey() {
      return this.$router.push({ name: "survey" });
    },
    goToEditSurvey(item) {
      const { code } = item;
      return this.$router.push({ name: "edit_survey", params: { code } });
    },
    showConfirmModal(item) {
      this.currentItem = item;
      this.confirmModal = true;
    },
    async removeSurvey() {
      const { code } = this.currentItem;
      try {
        this.loading = true;
        const url = `${this.$config.api_url}${this.$config.survey.survey}/${code}`;
        const response = await this.$httpService.delete(url);
        this.$notify.success(response.data.message);
        this.confirmModal = false;
        this.getData();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.grid-img-crd {
  /* width: 150px;
  height: auto;
  margin: auto;
  display: block; */
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  img {
    width: 95px;
    height: auto;
  }
}
.fs_1_3rem {
  font-size: 20px;
}
.w_h_35 {
  width: 35px;
  height: 35px;
}
</style>
